/** 套餐能力：来自 /auth/me 的 capabilities */

const FULL = Object.freeze({
  planCode: null,
  featureLimited: false,
  appAllowed: true,
  miniProgramAllowed: true,
  projectHouseType: true,
  projectMembers: true,
  projectBindCustomer: true,
  projectStages: true,
  projectProgress: true,
  projectNotices: true,
  projectPictures: true,
  projectSignins: true,
  reqStageRequired: true
})

export function planCapabilities(user) {
  if (user && user.capabilities && typeof user.capabilities === 'object') {
    return Object.assign({}, FULL, user.capabilities)
  }
  return FULL
}

export function isPlanLimited(user) {
  return !!planCapabilities(user).featureLimited
}

/** 账号用量文案：账号数 1/5；不限时显示 账号数 1/不限 */
export function accountUsageText(user) {
  if (!user) return ''
  const used = Number(user.userCount != null ? user.userCount : 0)
  const max = user.maxUsers
  if (max == null || max === '') return `账号数 ${used}`
  if (Number(max) <= 0) return `账号数 ${used}/不限`
  return `账号数 ${used}/${max}`
}

/** 盘点总数用量：未删除盘点明细条数 / 套餐上限 */
export function assetUsageText(user) {
  if (!user || user.maxCheckCount == null || user.maxCheckCount === '') return ''
  const used = Number(user.assetCount != null ? user.assetCount : 0)
  const max = Number(user.maxCheckCount)
  if (max <= 0) return `盘点明细 ${used}/不限`
  return `盘点明细 ${used}/${max}`
}

export function planNameOf(user) {
  if (!user) return ''
  if (user.planName) return String(user.planName)
  const code = String(user.planCode || '').toUpperCase()
  const map = {
    FREE: '免费版',
    STD: '标准版',
    PRO: '专业版',
    PRIVATE: '私有化部署',
    TRIAL: '试用版',
    BASIC: '基础版'
  }
  return map[code] || ''
}
